module.exports = __webpack_public_path__ + "static/media/icons8-rent.a20e600c.svg";